module.exports = __webpack_public_path__ + "36babb9a47891b8f50757e5884f1dd3f.pdf";